import { Skeleton } from "primereact/skeleton";
import styled from "styled-components";

const CustomSkeletonLoader = styled(Skeleton)`
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "1rem")};
  background-color: #f2f2f2;
  border-radius: 4px;
`;

const SkeletonLoader = (props) => {
  return <CustomSkeletonLoader animation="wave" {...props} />;
};

export default SkeletonLoader;
